import { AuthMFAGetAuthenticatorAssuranceLevelResponse } from '@supabase/supabase-js';

export const getAssuranceLevel = (
  assuranceLevel: AuthMFAGetAuthenticatorAssuranceLevelResponse['data'] | null
) => {
  if (!assuranceLevel) return null;
  if (assuranceLevel?.currentLevel === 'aal1' && assuranceLevel.nextLevel === 'aal2') return 'OFA';
  if (assuranceLevel?.currentLevel === 'aal2' && assuranceLevel?.nextLevel === 'aal2') return 'MFA';
};
